// extracted by mini-css-extract-plugin
module.exports = {"icon":"UnderMaintenance_icon__eFNuW","container":"UnderMaintenance_container__1R5fN"};